import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import BlogThumbnail from "../components/BlogThumnail"; 
import bum from "./content/pics/bumble.jpg";
import bum2 from "./content/pics/bumble2.jpeg";
import "./ShortStories.css"

const ShortStories = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("all");

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="Full">
    <div className="all">
    <div className="filler"/>
      <div className="sidebar">
        <button className={`toggle-button ${isOpen ? "open" : ""}`} onClick={toggleSidebar}>
          <div className={`hamburger-icon ${isOpen ? "close" : ""}`}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </button>
        <Sidebar isOpen={isOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
      </div>
      <div className="main-content">
        <div className="links-containerc">
          <a href="/">Home</a>
          <a href="/content">Content</a>
          <a href="/aboutus">About Us</a>
        </div>

        <div className="titles">
        <center><h2>Short Stories</h2></center>
        </div>


        <div className="blog-thumbnailsa">
        <div className="blog-thumbnail-containera">
  <a href="/bumble2">
    <BlogThumbnail
      imageSrc={bum2}
      title="Love on a Bumble Lane-2"
      description="No offense, but where the hell is Daksh?"
    />
  </a>
</div>

        <div className="blog-thumbnail-containera">
  <a href="/bumble">
    <BlogThumbnail
      imageSrc={bum}
      title="Love on a Bumble Lane"
      description="No offense, but anything can happen with just one swipe. Is it love, or a lesson?"
    />
  </a>
</div>
</div>
        
      </div>
    </div>
    </div>
  );
};

export default ShortStories;
